import React, { useState } from 'react';
import { TextField, InputLabel, Select, MenuItem, Grid, CircularProgress, FormControl, Button } from '@material-ui/core';
import { ACHTypeEnum, ACHAccountHolderTypeEnum } from '../../../services/V2/gozer';

export function TokenUpdate({
    updateToken,
    isCCToken,
    onSubmit,
    onCancel }) {
    const [working, setWorking] = useState<boolean>(false)
    let [model, setModel] = useState<any>(
        {
            firstName: updateToken?.firstName,
            lastName: updateToken?.lastName,
            streetAddress: updateToken?.streetAddress,
            city: updateToken?.city,
            state: updateToken?.state,
            zip: updateToken?.zip,
            expirationMonth: updateToken?.expirationMonth,
            expirationYear: updateToken?.expirationYear,
            achType: updateToken?.achType,
            achAccountHolderType: updateToken?.achAccountHolderType
        });


    let submit = () => {
        setWorking(true)
        onSubmit(model)
    }

    const handleChange = event => {
        let name = event.target.name;
        let value = event.target.value === "" ? null : event.target.value;

        if (event.target.type === "checkbox") {
            name = event.target.id;
            value = event.target.checked
        }
        setModel({
            ...model,
            [name]: value
        })
    }

    return (<div>
        <form style={{ textAlign: "left" }}>
            <TextField
                onChange={handleChange}
                margin="normal"
                id="firstName"
                name="firstName"
                label="First Name"
                type="text"
                value={model?.firstName}
                fullWidth
            />
            <TextField
                onChange={handleChange}
                margin="normal"
                id="lastName"
                name="lastName"
                label="Last Name"
                type="text"
                value={model?.lastName}
                fullWidth
            />
            <TextField
                onChange={handleChange}
                margin="normal"
                id="streetAddress"
                name="streetAddress"
                label="Address"
                type="text"
                value={model?.streetAddress}
                fullWidth
            />
            <TextField
                onChange={handleChange}
                margin="normal"
                id="city"
                name="city"
                label="City"
                type="text"
                value={model?.city}
                fullWidth
            />
            <TextField
                onChange={handleChange}
                margin="normal"
                id="state"
                name="state"
                label="State"
                type="text"
                value={model?.state}
                fullWidth
            />
            <TextField
                onChange={handleChange}
                margin="normal"
                id="zip"
                name="zip"
                label="Zip"
                type="text"
                value={model?.zip}
                fullWidth
            />
            {isCCToken ?
                <>
                <TextField
                    onChange={handleChange}
                    margin="normal"
                    id="expirationMonth"
                    name="expirationMonth"
                    label="Epiration Month"
                    type="number"
                    value={model?.expirationMonth}
                    fullWidth
                />
                <TextField
                    onChange={handleChange}
                    margin="normal"
                    id="expirationYear"
                    name="expirationYear"
                    label="Expiration Year"
                    type="number"
                    value={model?.expirationYear}
                    fullWidth
                />
                </>
            : <>
                <FormControl style={{minWidth: "100%", marginBottom: "10px"}}>
                    <InputLabel id="achType">Account Type</InputLabel>
                    <Select
                        labelId="achType"
                        name="achType"
                        value={model === undefined
                            || model === null ? "" : model?.achType}
                        label="Account Type"
                        onChange={handleChange}
                        fullWidth>
                        <MenuItem value={ACHTypeEnum.CHECKING}>Checking</MenuItem>
                        <MenuItem value={ACHTypeEnum.SAVINGS}>Savings</MenuItem>
                    </Select>
                </FormControl>
                <FormControl style={{minWidth: "100%", marginBottom: "10px"}}>
                    <InputLabel id="achAccountHolderType">Account Holder Type</InputLabel>
                    <Select
                        labelId="achAccountHolderType"
                        name="achAccountHolderType"
                        value={model === undefined
                            || model === null ? "" : model?.achAccountHolderType}
                        label="Account Holder Type"
                        onChange={handleChange}
                        fullWidth>
                        <MenuItem value={ACHAccountHolderTypeEnum.PERSONAL}>Personal</MenuItem>
                        <MenuItem value={ACHAccountHolderTypeEnum.BUSINESS}>Business</MenuItem>
                    </Select>
                </FormControl>
            </>}
        </form>

        <Grid>
            <Button variant="contained"
                className="green-button uvp-button"
                disabled={model?.zip === "" ||
                    (isCCToken && 
                    (model?.expirationMonth === "" || model?.expirationYear === ""))}
                id="submit"
                type="button"
                onClick={submit}
                style={{marginRight:"10px"}}>
                {working ?
                    ' Please Wait...'
                    : 'Submit'
                }
            </Button>
            {onCancel &&
                <Button variant="contained"
                    className="gray-button uvp-button"
                    id="cancel"
                    type="button"
                    onClick={onCancel}>
                    Cancel
            </Button>}
        </Grid>
        {working &&
            <>
                <div className='loading-container'><CircularProgress className='center-spinner' color="primary" /></div>
            </>
        }
    </div>)
}
